import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    teamname: '',
    username: '',
    useremail: '',
    signedin: false,
    logreason: '',
    logdate: '',
    teamslackid: '',
    teamid: '',
    chartdays: null,
    charttimes: null,
    todaychart: null,
    lastactivity: ''
  },
  mutations: {
    _useremail (state, email) {
      state.useremail = email;
    },
    _username (state, name) {
      state.username = name;
    },
    _teamname (state, team) {
      state.teamname = team;
    },
    _signedin (state, signedin) {
      state.signedin = signedin;
    },
    _logreason (state, reason) {
      state.logreason = reason;
    },
    _logdate (state, date) {
      state.logdate = date;
    },
    _chartdays (state, days) {
      state.chartdays = days;
    },
    _charttimes (state, times) {
      state.charttimes = times;
    },
    _todaychart (state, timein) {
      state.todaychart = timein;
    },
    _slackid (state, id) {
      state.teamslackid = id;
    },
    _teamid (state, id) {
      state.teamid = id;
    },
    _lastactivity (state, activity) {
      state.lastactivity = activity
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js